import 'reflect-metadata'
import { Inject } from 'inversify-props'
import {
  CreditMemoDocument,
  CreditMemoQuery,
  CreditMemoQueryVariables,
} from '~/graphql/types'
import { creditMemoStore } from '~/utils/store-accessor'
import { ApolloClientService } from '~/services/apollo-client.service'
import { UserService } from '~/services/user.service'

export class CreditMemoService {
  @Inject('ApolloClientService') apolloClientService!: ApolloClientService
  @Inject('UserService') userService!: UserService

  public store = creditMemoStore

  async fetchAll(force = false) {
    if (this.store.fetchStarted && !force) {
      return
    }
    this.store.setFetchStarted(true)
    const data = (
      await this.apolloClientService.client.query<
        CreditMemoQuery,
        CreditMemoQueryVariables
      >({
        query: CreditMemoDocument,
        variables: {
          where: {
            customer_erp_id: {
              _eq: this.userService.customerErpId,
            },
          },
        },
      })
    ).data

    if (data) {
      this.store.setItems(data.credit_memo)
    }
    this.store.setLoading(false)
  }

  get loading() {
    return this.store.loading
  }
}
